import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './StatisticsPanel.css';

function StatisticsPanel({ tasks }) {
  const { t } = useLanguage();

  // Calcular estadísticas
  const tasksWithTime = tasks.filter(task => task.total_time_seconds && task.total_time_seconds > 0);
  
  const totalSeconds = tasks.reduce((sum, task) => sum + (task.total_time_seconds || 0), 0);
  const totalHours = Math.floor(totalSeconds / 3600);
  const totalMinutes = Math.floor((totalSeconds % 3600) / 60);
  const totalSecs = totalSeconds % 60;

  const avgSeconds = tasksWithTime.length > 0 ? Math.floor(totalSeconds / tasksWithTime.length) : 0;
  const avgHours = Math.floor(avgSeconds / 3600);
  const avgMinutes = Math.floor((avgSeconds % 3600) / 60);
  const avgSecs = avgSeconds % 60;

  const formatTime = (hours, minutes, seconds) => {
    if (hours > 0) {
      return `${hours}h ${minutes}m`;
    } else if (minutes > 0) {
      return `${minutes}m ${seconds}s`;
    } else if (seconds > 0) {
      return `${seconds}s`;
    }
    return t('statisticsNoTime');
  };

  // Encontrar tarea más rápida y más demorada
  let fastestTask = null;
  let slowestTask = null;

  if (tasksWithTime.length > 0) {
    fastestTask = tasksWithTime.reduce((min, task) => 
      (task.total_time_seconds < (min?.total_time_seconds || Infinity)) ? task : min
    );
    slowestTask = tasksWithTime.reduce((max, task) => 
      (task.total_time_seconds > (max?.total_time_seconds || 0)) ? task : max
    );
  }

  const formatTaskTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return formatTime(hours, minutes, secs);
  };

  if (tasksWithTime.length === 0) {
    return (
      <div className="statistics-panel">
        <p className="statistics-empty">{t('statisticsNoTime')}</p>
      </div>
    );
  }

  return (
    <div className="statistics-panel">
      <div className="statistics-grid">
        <div className="statistic-item">
          <div className="statistic-label">{t('statisticsTotalTime')}</div>
          <div className="statistic-value">
            {formatTime(totalHours, totalMinutes, totalSecs)}
          </div>
        </div>

        <div className="statistic-item">
          <div className="statistic-label">{t('statisticsAvgTime')}</div>
          <div className="statistic-value">
            {formatTime(avgHours, avgMinutes, avgSecs)}
          </div>
        </div>

        {fastestTask && (
          <div className="statistic-item">
            <div className="statistic-label">{t('statisticsFastestTask')}</div>
            <div className="statistic-value statistic-task">
              <span className="statistic-task-text">{fastestTask.text}</span>
              <span className="statistic-task-time">
                {formatTaskTime(fastestTask.total_time_seconds)}
              </span>
            </div>
          </div>
        )}

        {slowestTask && (
          <div className="statistic-item">
            <div className="statistic-label">{t('statisticsSlowestTask')}</div>
            <div className="statistic-value statistic-task">
              <span className="statistic-task-text">{slowestTask.text}</span>
              <span className="statistic-task-time">
                {formatTaskTime(slowestTask.total_time_seconds)}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default StatisticsPanel;

